<template>
  <v-container id="project-costs" fluid tag="section" class="main-container">
    <idc-component-bid-costings
      show-history-of-costings
      :bid-number="bidNumber"
      :settings="settings"
      :specifications="specifications"
      :center-coordinates="centerCoordinates"
      :summary="summary"
      :calculated="calculated"
      :totals="totals"
      :base-url="path.SALES_BIDS_COST"
    />
  </v-container>
</template>

<script>
  import Vue from 'vue'
  import { mapActions, mapState, mapMutations } from 'vuex'
  import BidNumber from '@/utilities/bid/BidNumber'
  import RouteQuery from '@/utilities/core/route/RouteQuery'
  import Path from '@/utilities/bid/enums/Path'

  export default Vue.extend({
    name: 'DashboardBidCostings',
    components: {
      IdcComponentBidCostings: () => import('@/components/idc/bids/cost/Costings'),
    },
    data: () => ({
      path: Path,
    }),
    computed: {
      ...mapState('Settings', ['settings']),
      ...mapState('Bid', ['specifications', 'bidNumber', 'centerCoordinates', 'summary']),
      ...mapState('Bid/Cost', ['calculated', 'totals']),
    },
    watch: {
      '$route.params.id'(id) {
        this.init(+id)
      },
    },
    created() {
      this.init(+this.$route.params.id)
    },
    methods: {
      ...mapActions('Bid', ['fetchSpecifications', 'fetchSummary']),
      ...mapActions('Project/Overview', ['fetchCostings']),
      ...mapMutations('Bid', ['setBidNumber']),
      ...mapMutations('Bid/Cost', ['resetAll', 'setCalculated', 'setConstants', 'setTotals']),

      init(id) {
        this.resetAll()
        this.initBidNumber(id)
      },

      async initBidNumber(id) {
        const bidNumber = new BidNumber()
        const num = RouteQuery.bidNumber(this.$router) ?? this.bidNumber ?? bidNumber.getFirst()

        this.setBidNumber(num)

        await Promise.all([this.fetchSummary({ bidNumber: num }), this.fetchSpecifications(num)])

        try {
          const { calculated, constants } = await this.fetchCostings({ bidNumber: num, record: id })

          this.setCalculated(calculated)
          this.setConstants(constants)
        } catch (err) {
          this.$router.push({ path: `${Path.SALES_BIDS_COST}/${this.bidNumber}` })
        }
      },
    },
  })
</script>
